// @ts-nocheck
import * as selectors from './domainSelectors';

export { selectors };
